import { render, staticRenderFns } from "./PaymentProviderLegalPlate.vue?vue&type=template&id=bee57884&scoped=true"
import script from "./PaymentProviderLegalPlate.vue?vue&type=script&lang=js"
export * from "./PaymentProviderLegalPlate.vue?vue&type=script&lang=js"
import style0 from "./PaymentProviderLegalPlate.vue?vue&type=style&index=0&id=bee57884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee57884",
  null
  
)

export default component.exports